export const NOTIFICATION_TYPES = {
  GOOGLE_UPDATE: 'Google update',
  NEW_REVIEW: 'New Review',
  UPDATED_REVIEW: 'Updated Review',
  NEW_CUSTOMER_MEDIA: 'New Customer Media',
  NEW_QUESTION: 'New Question',
  UPDATED_QUESTION: 'Updated Question',
  NEW_ANSWER: 'New Answer',
  UPDATED_ANSWER: 'Updated Answer',
  DUPLICATE_LOCATION: 'Duplicate Location',
  NOTIFICATION_TYPE_UNSPECIFIED: 'Unspecified',
}
